import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useChapterTopics(data = {}) {
  const { enabled = false, queryParams = '', classID, subjectID, chapterID } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getTopics() {
    return privateFetch
      .get(
        `/v1/admin/class/${classID}/subject/${subjectID}/chapter/${chapterID}/topic${queryParams}`
      )
      .then((res) => res.data);
  }

  return useQuery(['subject-chapter-topics', { data }], getTopics, { enabled });
}

export default useChapterTopics;
